import Vue from "vue"
import MintUI from 'mint-ui'
import VueRouter from 'vue-router'
import axios from 'axios'

import "./css/min-ui.min.css";
import "./css/style.css";
import "./css/sidenav.css";
import "./lib/fa/css/font-awesome.min.css";

import routes from './js/routes'
import fun from "./js/fun"
import filter from "./js/filter"
import App from "./App.vue";


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
  // mode: 'history',
   routes 
})


router.beforeEach((to, from, next) => {
  window.scrollTo(0,0);
  MintUI.Indicator.close();//关闭正在加载中
  // var path=location.hash;
  // var url=path.substr(2,4);
  next()
})
router.afterEach(function(){
  //console.log("离开了页面");
})

Vue.use(MintUI)
Vue.use(VueRouter)

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';//没有用

var host=location.host.match(/localhost/)?"http://test.dyjk.cn":"http://183.238.185.163:4400"
console.log("host",host);

window.axios=axios;
window.api=host+"/Apiall/Api/";
window.picurl=host+"/Public/";
window.payhost=location.host.match(/localhost/)?"http://test.dyjkweb.cn":"http://www.dyjk.cn";
window.fun=fun;
window.router=router;
window.mydata={
  nav:"/",
  back:false,
  navshow:false,
  header:true,
  userheader:false,
  api:host+"/Apiall/",
  apiuser:host+"/Apiall/Apiuser/",
  host:host,
  width:window.innerWidth,
};


new Vue({
  el: '#app',
  router,
  filters: filter,
  components:{App},
  template: '<App/>',
})

//vue全局配置
// Vue.config.silent=false;
// Vue.config.devtools = false;
//Vue.config.productionTip=false;




// WEBPACK FOOTER //
// ./src/main.js